import type { RawDraftContentState } from '@ms/yammer-content-state';

import type { Publisher } from './types';

const inlineImageBlockTypes = new Set(['image']);

const getInlineAttachmentIds = (
  rawContentState: RawDraftContentState | undefined,
  blockTypes: ReadonlySet<string>
): Publisher['inlineAttachmentIds'] =>
  (rawContentState?.blocks ?? []).flatMap((block) =>
    blockTypes.has(block.type) && typeof block.data?.id === 'string' ? [block.data.id] : []
  );

export const getInlineImageAttachmentIds = (
  rawContentState: RawDraftContentState | undefined
): Publisher['inlineAttachmentIds'] => getInlineAttachmentIds(rawContentState, inlineImageBlockTypes);
